import PropTypes from 'prop-types';

function RenderIf({ condition, children, renderElse = false }) {
  return condition ? children : renderElse;
}

export default RenderIf;

RenderIf.propTypes = {
  condition: PropTypes.bool.isRequired,
};
